import React from "react";
import { ToggleCard } from "../../UI/DesignStandards/Toggles/ToggleCard";
import { FaInfoCircle } from "react-icons/fa";

export const SidePotSelection = ({
  sidePotEvents,
  selectedSidePots,
  onToggle,
  disabled = false,
  allEventConfigs = [],
  allEventStatus = null,
  selectedEvent = null,
  getAllEventStatus = null,
  currentTeamId = null, // Optional: for edit mode to allow removing currently selected all events
}) => {
  if (!sidePotEvents || sidePotEvents.length === 0) {
    return null;
  }

  // Helper to check if an event is an all event
  const isAllEvent = (eventId) => {
    return allEventConfigs.some((config) => config.allEventId === eventId);
  };

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {sidePotEvents.map((event) => {
          const isAllEventType = isAllEvent(event.id);
          const status =
            isAllEventType && getAllEventStatus
              ? getAllEventStatus(
                  event.id,
                  allEventStatus,
                  allEventConfigs,
                  selectedEvent,
                  currentTeamId, // Pass current team ID for edit mode
                  selectedSidePots[event.id] || false // Pass whether it's currently selected
                )
              : { message: null, disabled: false };

          // For all events: check if bowler already has an entry (already paid)
          // If they have any entry for this all event config, show "Paid"
          const hasAlreadyPaid =
            isAllEventType &&
            allEventStatus &&
            allEventStatus.hasEnteredAllEvents &&
            allEventStatus.hasEnteredAllEvents[event.id] === true;

          const feeSubtitle = hasAlreadyPaid
            ? "Paid"
            : `Entry Fee: $${event.entryFee || 0}`;

          return (
            <div key={event.id} className="space-y-1">
              <ToggleCard
                checked={selectedSidePots[event.id] || false}
                onChange={() => onToggle(event.id)}
                title={event.eventName}
                subtitle={feeSubtitle}
                disabled={disabled || status.disabled}
                className="text-sm"
              />
              {isAllEventType && status.message && (
                <div
                  className={`flex items-center space-x-1 text-xs ${status.message.color}`}
                >
                  <FaInfoCircle className="text-xs" />
                  <span>{status.message.text}</span>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {disabled && (
        <div className="text-xs text-brand-muted">
          Complete bowler name to enable side pot selection
        </div>
      )}
    </div>
  );
};
